'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (SmsStatusType) {
    SmsStatusType["sent"] = "sent";
    SmsStatusType["pending"] = "pending";
    SmsStatusType["canceled"] = "canceled";
    SmsStatusType["failed"] = "failed";
    SmsStatusType["received"] = "received";
    SmsStatusType["invalid"] = "invalid";
})(exports.SmsStatusType || (exports.SmsStatusType = {}));
